<template>
  <div>
    <h1 class="ml-2">Highlight</h1>
    <b-card>
      
      <b-tabs content-class="mt-3" fill v-model="tabIndex" v-if="tabModules">
        <b-tab v-for="(modules , index) in tabModules"  :title="modules.tabName">
          <!-- {{modules}} {{tabLoad}} {{evalVar(modules.component + 'Filter' , 'filter')}} -->
          <!-- {{modules.component}} -->
          <component 
            :is="modules.component"
            :options="options" 
            :period="period" 
            :mobile="mobile" 
            v-if="tabLoad[index]" 
            :data="evalVar(modules.component + 'Data' , 'data')"
            :filter="evalVar(modules.component + 'Filter' , 'filter')"
            @search="search(period , null , null)"
            @loadAPI="loadAPI"
            :weekNo="weekNo"
            :rangeOption="rangeOption"
            @weekNo="changeWeekNo"
            style="min-height:43px"
          />
          <!-- {{tabLoad[index]}} {{index}} -->
          <!-- {{evalVar(modules.component + 'Data')}} -->
        </b-tab>
        <!-- <b-tab title="Stock Overview" active>
          <stockOverview 
            :options="options" 
            v-if="tabLoad[0]" 
            :data="stockOverviewData"
            :filter="filter.stockOverviewFilter" 
            @search="search(period , null , null)"
            @loadAPI="loadAPI"
            :rangeOption="rangeOption"
            style="min-height:43px"
          >
          </stockOverview>
        </b-tab>

        
        <b-tab title="Stock Analytics" :disabled="apiLoading && !tabLoad[1]">
          <stockAnalytics
            
            :options="options" 
            :period="period" 
            :mobile="mobile" 
            v-if="tabLoad[1]" 
            :data="stockAnalyticsData"
            :filter="filter.stockAnalyticsFilter"
            @search="search(period , null , null)"
            @loadAPI="loadAPI"
            :weekNo="weekNo"
            :rangeOption="rangeOption"
            @weekNo="changeWeekNo"
          >
          </stockAnalytics>
        </b-tab>


        <b-tab title="Late Delivery and Shipping" :disabled="apiLoading && !tabLoad[2]">
          <lateDeliveryAndShipping 
            :options="options" 
            :period="period" 
            :mobile="mobile" 
            :data="lateDeliveryAndShippingData"
            :filter="filter.lateDeliveryAndShippingFilter"
            @search="search(period , null , null)"
            @loadAPI="loadAPI"
            :rangeOption="rangeOption"
            v-if="tabLoad[2]">
          </lateDeliveryAndShipping>
        </b-tab>

        <b-tab title="Sales Analysis" :disabled="apiLoading && !tabLoad[3]">
          <salesAnalysis 
            :options="options" 
            :period="period" 
            :mobile="mobile" 
            :data="salesAnalysisData"
            :filter="filter.salesAnalysisFilter"
            @search="search(period , null , null)"
            @loadAPI="loadAPI"
            v-if="tabLoad[3]"> 
          </salesAnalysis>
        </b-tab>

        <b-tab title="Territory Management" :disabled="apiLoading && !tabLoad[4]">
          <territoryManagement 
            :options="options" 
            :period="period" 
            :mobile="mobile" 
            v-if="tabLoad[4]"
            :data="territoryManagementData"
            :rangeOption="rangeOption"
            @search="search(period , null , null)"
            @loadAPI="loadAPI"
            :filter="filter.territoryManagementFilter">
            
          </territoryManagement>
        </b-tab>


        <b-tab title="Mapping Summary" :disabled="apiLoading && !tabLoad[5]">
          <mappingSummary 
            :options="options" 
            :period="period" 
            :mobile="mobile" 
            v-if="tabLoad[5]"
            @search="search(period , null , null)"
            @loadAPI="loadAPI"
            :filter="filter.mappingSummaryFilter"
            :rangeOption="rangeOption"
            :data="mappingSummaryData">
          </mappingSummary>
        </b-tab>


        <b-tab title="Service Analysis" :disabled="apiLoading && !tabLoad[6]">
          <serviceAnalysis 
            :options="options" 
            :period="period" 
            :mobile="mobile" 
            v-if="tabLoad[6]"
            @search="search(period , null , null)"
            @loadAPI="loadAPI"
            :filter="filter.serviceAnalysisFilter"
            :data="serviceAnalysisData">
          </serviceAnalysis>
        </b-tab> -->
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
  function isRTL () {
  return document.documentElement.getAttribute('dir') === 'rtl' ||
    document.body.getAttribute('dir') === 'rtl'
  }

  import Multiselect from 'vue-multiselect'
  import * as am4core from "@amcharts/amcharts4/core"
  import flatPickr from 'vue-flatpickr-component'
  import moment from 'moment'

  import stockOverview from './tabChildren/stockDetails'
  import stockAnalytics from './tabChildren/stockAnalytics'
  import lateDeliveryAndShipping from './tabChildren/lateDeliveryAndShipping'
  import salesAnalysis from './tabChildren/salesAnalysis'
  import territoryManagement from './tabChildren/territoryManagement'
  import mappingSummary from './tabChildren/mappingSummary'
  import serviceAnalysis from './tabChildren/serviceAnalysis'
  import listUrl from './listUrl.js'

  export default {
    name: 'Highlight',
    data () {
      let range = `${new moment().startOf('month').format('Y-MM-DD')} to ${new moment().format('Y-MM-DD')} `
      // console.log(range)
      return {
        mobile : this.isMobile(),
        apiLoading : false,
        source : null,
        CancelToken : this.$http.CancelToken,
        buttonArray: ['MTD' , 'Last Month' , 'YTD' , 'Last Year' , 'Custom'],
        period : 1,
        // For Easy Use of MultiSelect
        rangeOption : {
          Semester : {},
          Quarterly : {},
          Monthly : {}
        },
        options : this.$store.getters.getFilterOptions,
        filterString : '',
        // modal settings
        showCustomModal: false,
        rangeConfig: {
          mode: 'range',
          altInput: true,
          animate: !isRTL()
        },
        seperatedRangeConfig: {
          altInput: true,
          altInputClass: 'form-control input flatpickr-input-highlight',
          animate: !this.isRTL(),
        },
        range: range,
        modalError: '',
        dateStart : `${new moment().startOf('month').format('Y-MM-DD')}`,
        monthTo : {
          name : new moment().format("MMMM"),
          value : parseInt(new moment().format("M"))
        },
        weekNo : 1,

        // filter settings
        filter: {
          stockOverviewFilter: {
            stockOverview : { 
              period : new moment().add(-1 , 'days').format('Y-MM-DD')
            },
            mainDealerStockOptions: {
              segment : '',
              type : '',
              color : '',
              period : new moment().add(-1 , 'days').format('Y-MM-DD')
              // period : "2020-12-15"
            },
            stockSales : {
              series : '',
              color : '',
              region : '',
              type : ''
            },
            dealerStockOptions: {
              karesidenan : '',
              city : '',
              segment : '',
              type : '',
              color : '',
              period : new moment().add(-1 , 'days').format('Y-MM-DD')
            }
          },
          stockAnalyticsFilter: {
            outerStockOptions : {
              type : '',
              series : '',
              color : ''
            },
            movementStockOptions : {
              warehouse : '',
              destination : '',
              mainDealer : '',
              segment : '',
              type : '',
              color : '',
              start : new moment().startOf('month').format("Y-MM-DD"),
              end : new moment().format("Y-MM-DD")
              // warehouse : '',
              // destination : '',
              // category: '',
              // by: { code: 'destination' , name : 'By Destination ( Out )'},
            },
            stockDaysOptions : {
              mainDealer : '',
              type : '',
              color : '',
              month : new moment().month() + 1,
              year : new moment().year()
            },
            stockDaysOptionsDealer : {
              dealer : '',
              karesidenan : '',
              type : '',
              color : '',
              month : new moment().month() + 1,
              year : new moment().year()
            },
            agingStockOptions : {
              mainDealer : '',
              warehouse : '',
              model : '',
              color : '',
              period : new moment().format('Y-MM-DD')
            },
            agingStockOptionsDealer : {
              dealer : '',
              karesidenan : '',
              model : '',
              color : '',
              period : new moment().format('Y-MM-DD')
            },
            stockByProductionYearsOptions : {
              mainDealer : '',
              warehouse : ''
            },
            stockByProductionYearsOptionsDealer : {
              dealer : '',
              karesidenan : ''
            },
            stockDaysMarket : {
              type : ''
            }
            // averageAgingStockOptions : {
            //   segment : '',
            //   karesidenan : ''
            // }
          },
          lateDeliveryAndShippingFilter: {
            lateDeliveryShipping : {
              type : 'by_rit',
              start : new moment().startOf('month').format("Y-MM-DD"),
              end : new moment().format("Y-MM-DD")
            },
            lateDeliveryShippingTransporterMD : {
              transporter : '',
              type: 'mdtod',
              start : new moment().startOf('month').format("Y-MM-DD"),
              end : new moment().format("Y-MM-DD")
            },
            lateDeliveryShippingTransporterAHM : {
              transporter : '',
              type: 'ahmtomd',
              start : new moment().startOf('month').format("Y-MM-DD"),
              end : new moment().format("Y-MM-DD")
            },
            leadtimeTransporter : {
              destination : '',
              start : new moment().startOf('month').format("Y-MM-DD"),
              end : new moment().format("Y-MM-DD")
            }
          },
          salesAnalysisFilter: {
            salesAnalysis : {
              semester : `S1 - ${(new Date()).getFullYear()}`,//s1 2020
              karesidenan : '',
              city : '',
              dealer : ''
            }
          },
          territoryManagementFilter: {
            territoryOptions: {
              area: 'Jawa Timur',
              type: '',
              color: '',
              dealer: '',
              start : new moment().startOf('month').format("Y-MM-DD"),
              end : new moment().format("Y-MM-DD"),
              start_service : new moment().startOf('month').format("Y-MM-DD"),
              end_service : new moment().format("Y-MM-DD"),
              start_service_2 :  new moment().startOf('month').format("Y-MM-DD"),
              end_service_2 : new moment().format('Y-MM-DD'),
              mapType : 'By Kecamatan',
              includeServiceDate : true,
              filterBy : 'ssu_date'
            },
          },
          mappingSummaryFilter : {
            mappingSummary : {
              start : new moment().startOf('month').format("Y-MM-DD"),
              end : new moment().format("Y-MM-DD")
            }
          },
          serviceAnalysisFilter: {
            serviceAnalysis : {
              semester : `S2 - ${(new Date()).getFullYear()}`,//s1 2020
              karesidenan : '',
              city : '',
              dealer : ''
            }
          }
        },

        // tab settings
        tabIndex: 0,
        tabLoad: [],
        tabShow: 'stockOverview',
        tabModules : null,

        // API Data 
        stockOverviewData: {
          stockOverview: null,
          stockOverviewDocument: null,
          stockOverviewVirtual: null,
          stockOverviewSipbUnfill: null,
          mainDealerStock: null,
          dealerStock: null,
          stockSales: null,
          stockOverviewStockInden : null
        },
        stockAnalyticsData: {
          outerStock : null,
          agingStockMD: null,
          agingStockD: null,
          agingStockEnd: null,
          agingStockMDMeta: null,
          agingStockDMeta: null,
          agingStockEndMeta: null,
          stockDaysMD: null,
          stockDaysD: null,
          stockDaysEnd: null,
          movementStockSubSeries: null,
          movementStockDestination: null,
          movementStockTable: null,
          averageAgingMD: null,
          averageAgingD: null,
          stockByProductionYearsMD: null,
          stockByProductionYearsD: null,
          stockDaysMarket : null
        },
        salesAnalysisData: {
          salesAnalysis: null,
          salesAnalysisWeekly: null
        },
        serviceAnalysisData: {
          serviceAnalysis: null,
          serviceAnalysisWeekly: null
        },
        mappingSummaryData: {
          mappingH1: null,
          mappingH2: null,
          mappingTotal: null
        },
        territoryManagementData: {
          territory: null,
          territoryService : null,
          territorySalesByDocument: null,
          territoryMarket : null,
          territoryMarketDocument : null,
          territoryMarketDealer : null
        },
        lateDeliveryAndShippingData: {
          delivery_ahm_to_md: null,
          delivery_md_to_d: null,
          transporter_ahm_to_md: null,
          transporter_md_to_d: null,
          leadtime_transporter: null
        }
      }
    },
    watch: {
      tabIndex: function () {
        this.tabLoad[this.tabIndex] = true
      },
      period: function () {
        this.tabLoad = new Array(6).fill(false)
        this.tabLoad[this.tabIndex] = true
        this.source.cancel('Filter Has Changed');
        this.search(this.period , null , null)
        
      },

      // // Filter TerritoryManagement
      // "filter.territoryManagementFilter": {
      //   deep: true,
      //   handler: function () {
      //     let url = ['/territory-management']
      //     let params = [{
      //       var: 'territory',
      //       parent: 'territoryManagementData',
      //       filter: 'territoryManagementFilter'
      //     }]

      //     this.search(this.period , url , params )
      //   }
      // },
      
      
    },
    beforeDestroy () {
      am4core.disposeAllCharts()
    },
    components : {
      Multiselect,
      flatPickr,
      stockOverview,
      stockAnalytics,
      lateDeliveryAndShipping,
      salesAnalysis,
      territoryManagement,
      mappingSummary,
      serviceAnalysis
    },
    mounted () {
      this.source = this.CancelToken.source();

      this.loadSettings()
      this.loadRangeOption()
    },
    beforeRouteLeave(to, from, next) {
      this.source.cancel('Leaving Highlights. Cancel All Pending Request.');
    },
    methods : {
      evalVar (string , type) {
        // console.log(this[string])
        if(type == 'data')
          return this[string]
        else
          return this.filter[string]
      },
      async loadSettings () {
        // console.log(await this.listModules())
        let modules = await this.listModules()
        // console.log(modules)

        let highlightChildren = modules.children
        this.tabLoad = new Array(highlightChildren.length).fill(false)
        this.tabLoad[0] = true

        this.tabModules = highlightChildren.map(x => ({
          tabName : x.title,
          is_load : false,
          component : x.title.charAt(0).toLowerCase() + x.title.split(' ').join('').substring(1),
        }))

        this.tabModules[0].is_load = true


      },
      async listModules () {
        let userAccess = this.$store.getters.currentUser;

        let modules = this.$store.state.modules

        // Safeguard if Modules Fail - Marv
        if(modules.length <= 0)
          modules = await this.loadModules()

        console.log(modules)

        // Remove Filter if Login is Super Admin ( Hasilnya Kosong kalau di filter ) - Marv
        if(userAccess.role == 'SUPER ADMIN' || userAccess.role == 'ADMIN')
          modules = JSON.parse(JSON.stringify(modules)).filter(x=> x.path && !x.path.includes('/dealer/'))
        else
          modules = JSON.parse(JSON.stringify(modules)).filter(x=>x.dealer_access==(userAccess.role == 'USER DEALER' ? 1 : 0))
        


        var allowed_roles = ['SUPER ADMIN', 'ADMIN']

        if(allowed_roles.indexOf(userAccess.role) === -1){
          let i = 0;
          while(modules[i]){
            if(!modules[i].children){
              if (userAccess.modules.map(x=>parseInt(x)).indexOf(modules[i].id) == -1) modules.splice(i, 1);
              else i++;
            } else {
              let j = 0;
              while(modules[i].children[j]){
                if (userAccess.modules.map(x=>parseInt(x)).indexOf(modules[i].children[j].id) == -1) modules[i].children.splice(j, 1);
                else j++;
              }
              if(modules[i].children.length == 0) modules.splice(i, 1)
              else i++;
            }
          }
        }

        //Add title 'Dashboard' (Marv Changes , Checks whether title List already exist or not)
        if(!modules.find(x => x.title == 'Dashboard'))
          modules.splice(0, 0, {icon:'li', title:'Dashboard'});

        return modules.find(x => x.title == 'Highlight')
      },
      changeWeekNo (value) {
        this.weekNo = value
      },
      loadRangeOption () {
        let startingYear = 2019
        let yearNow = parseInt(new moment().format("Y"))
        let monthNow = parseInt(new moment().format("M"))

        for(var i = yearNow; i >= startingYear ; i--) {
          
          this.rangeOption.Semester[`S2 ${i}`] = [new Date(i , 6 , 1) , new Date(i , 12 , 0)]
          this.rangeOption.Semester[`S1 ${i}`] = [new Date(i , 0 , 1) , new Date(i , 6 , 0)]

          this.rangeOption.Quarterly[`Q1 ${i}`] = [new Date(i , 0 , 1) , new Date(i , 3 , 0)]
          this.rangeOption.Quarterly[`Q2 ${i}`] = [new Date(i , 3 , 1) , new Date(i , 6 , 0)]
          this.rangeOption.Quarterly[`Q3 ${i}`] = [new Date(i , 6 , 1) , new Date(i , 9 , 0)]
          this.rangeOption.Quarterly[`Q4 ${i}`] = [new Date(i , 9 , 1) , new Date(i , 12 , 0)]
        }

        let unorderedMonth = {}

        for(var j = monthNow - 1 ; j >= monthNow - 12; j --) {
          let date = new moment(new Date(yearNow , j , 1));
          // console.log(date.format("Y") , date.format("M") , 1)
          unorderedMonth[`${date.format("MMM")} ${date.format("Y")}`] = [new Date(date.format("Y") , parseInt(date.format("M")) - 1 , 1) , new Date(date.format("Y"),parseInt(date.format("M")) ,0)]
          // console.log(unorderedMonth[`${date.format("MMM")} ${date.format("Y")}`])
        }

        // for(var j = monthNow - 1 ; j <= monthNow + 6; j ++ ){
        //   let date = new moment(new Date(yearNow , j , 1));
        //   unorderedMonth[`${date.format("MMM")} ${date.format("Y")}`] = [new Date(date.format("Y") , date.format("M") , 1) , new Date(date.format("Y"),date.format("M") + 1 ,0)]
        // }
      
        
        
        
        this.rangeOption.Monthly = unorderedMonth

      },
      translateIndex (index) {
        let array = ['stockOverview' , 'stockAnalytics' , 'leadTime' , 'salesAnalysis', 'territoryManagement', 
        'mappingSummary', 'serviceAnalysis']

        return array[index]
      },
      async search (index, url, params) {
        if(!url && !params) {
          url = listUrl.stringUrl[this.translateIndex(this.tabIndex)]
          params = listUrl.param[this.translateIndex(this.tabIndex)]
        }
        let keys = Object.keys(url)

        for(var i = 0 ; i < keys.length ; i ++) {
          this.source = this.CancelToken.source();
          this.loadAPI(url[keys[i]] , params[keys[i]]) 
        }
      },

      // This Function is used to load All API
      async loadAPI (url , params) {
        this.apiLoading = true
        let apiCount = url.length
        let counter = 0

        for(var i = 0 ; i < url.length ; i++) {
          let filter = url[i].includes('?') ? '&' : '?'
          let variable = params[i].var
          let parent = params[i].parent
          let filterHeader = params[i].filter
          let filterVar = params[i].filterVar
          this[parent][variable] = null
          
          if(this[parent][variable + 'Meta']) this[parent][variable + 'Meta'] = null

          let individualFilter = filter
          // Add Localised Filter Options to API

          if (filterVar) {
            let filterOptions = await this.transformFilter(this.filter[filterHeader][filterVar])
            individualFilter = await this.initialiseFilter(filter + '&' , filterOptions)
          }
          else if(this.filter[filterHeader] && this.filter[filterHeader][variable + 'Options']){
              let filterOptions = await this.transformFilter(this.filter[filterHeader][variable + 'Options'])
              individualFilter = await this.initialiseFilter(filter + '&' , filterOptions)
          }
          
          // Validation For Territory ( Requirement to choose 1 dealer before hitting the API )
          if(variable.includes('territory')) {
            
            if(!this.filter[filterHeader].territoryOptions.includeServiceDate) {
              let start_service = this.filter[filterHeader].territoryOptions.start_service
              let end_service = this.filter[filterHeader].territoryOptions.end_service
              individualFilter = individualFilter.split(`&start_service=${start_service}&end_service=${end_service}`).join('')
                          
            }
            // console.log(individualFilter)

            if(this.filter[filterHeader][filterVar ? filterVar : variable + 'Options'].dealer == '' || !this.filter[filterHeader][filterVar ? filterVar : variable + 'Options'].dealer) {
              if(counter == apiCount - 1)
                this.apiLoading = false
              else
                counter ++
              
              continue;
            }
          }

          if(variable == 'movementStockTable' || variable == 'movementStockSubSeries' || variable == 'movementStockDestination') {
            if(!this.filter[filterHeader].movementStockOptions.destination || !this.filter[filterHeader].movementStockOptions.warehouse) {
              continue;
            }
          }

          if(variable == 'salesAnalysisWeekly' || variable == 'serviceAnalysisWeekly') individualFilter += '&monthly=0'

          

          this.$http.get('/api/highlight' + url[i] + individualFilter, {cancelToken : this.source.token})
          .then((resp) => {

            if(counter == apiCount - 1)
              this.apiLoading = false
            else
              counter ++
            
            this[parent][variable] = resp.data.data

            if(resp.data.meta)
                this[parent][variable + 'Meta'] = resp.data.meta
          })
          .catch((err) => {

            if(counter == apiCount - 1)
              this.apiLoading = false
            else
              counter ++


            if(this.$http.isCancel(err)) {
              console.log('Cancelled')
            }
            else {
              console.log(err)
            }
          })
        }
        },
    }
  }
</script>

<style scoped>
  .searchHeightButton {
    min-height: 40px;
  }

  .btn-primary {
    background-color: #FF9700;
    border-color: transparent;
    box-shadow: 1px 1px 3px 3px lightgrey;
    color:white;
  }

  .btn-outline-primary {
    color: #FF9700;
    box-shadow: 0 0 0 1px #FF9700 inset;
    border-color: transparent;
  }

  .btn-outline-primary:hover {
    color: white;
    background-color: #FF9700; 
  }

  .content-outer{
    padding:0 1.25%;
  }

  .content-inner{
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);
    border-radius: 6px;
    margin-top:8px;
    overflow-x : auto;
  }
</style>

<style>
    .leaflet-touch .leaflet-control-layers, .leaflet-touch .leaflet-bar {	
      -webkit-box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.16);	
      -moz-box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.16);	
      box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.16);	
      border : none;	
    }	
    h6 {	
      font-size: 0.8rem;	
      color: #b2b2b2;	
      font-weight: 700;	
    }	

    h3 {	
      color : #707070;	
    }
    .form-control[readonly] {
      background-color: white !important;
    }
    .flatpickr-input-highlight {
      height:40px;
      background-color: white !important;
      margin-top:auto;

    }
    .nav-tabs .nav-link {
    border: 1px solid transparent;
    border-bottom: 1px solid #656f78;
    }

    .nav-link.active {
    border-bottom: none;
    }

  .Aligner-Header {
    padding-left:3% !important;
    color: #707070;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .Aligner-Header h3 {
    font-size: 24px;
  }  

  .highlightFilter .multiselect__tags  {
      background-color: #FF9700 !important;
  }

  .highlightFilter .multiselect__single , .highlightFilter .multiselect__input , .highlightFilter .multiselect__input::placeholder , .highlightFilter .multiselect__placeholder {
      background-color: #FF9700 !important;
      color: white;
  }
  
  .highlightFilter .multiselect__select:before{
    color: white !important;
  }

  .disabledButton .multiselect__select {
      background-color: #FF9700
  }

  .moreButton {
    text-align: center;
    vertical-align: middle;
    color: grey;
    cursor: pointer;
  }

  .moreButton:hover{
    text-decoration: underline;
  }
</style>

<style>
  .multiselect__single {
    font-size : 13px
  }
  .multiselect__input {
    font-size : 13px;
  }
  .multiselect__tags {
    font-size : 13px;
  }
  .multiselect {
    font-size : 13px;
  }
  body .daterangepicker.show-ranges .ranges {
    padding-left:10px;
    height:250px;
    overflow-y:scroll;
  }
  .reportrange-text {
    min-height:40px;
    display:flex;
    align-items: center;
  }
.modal-mask {
        position: fixed;
        z-index: 1050;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 10px 0;
    }

    .modal-default-button {
        float: right;
    }

    /*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    /* MODAL STARTS */
    .modal-body{
        margin:0
    }

    .modal-body .moduleLine{
        margin-bottom: 0vh;
    }

    .modal-body .moduleLine a{
        text-decoration: none;
    }

    .modal-body .moduleLine .moduleBox:hover{
        background-color: #E0E0E0;
        transition: background-color 0.7s ease;
        color: #212121;
        transition: color 0.7s ease;
    }

    .modal-body .moduleLine .moduleBox{
        border:1px solid #BDBDBD;
        border-radius: 20px;
        padding: 20px 0;
        color:black;
        margin-bottom: 3vh;
    }

    .modal-body .moduleLine .moduleBox i{
        font-size:5vh;
    }

    h3.modalHeadline{
        margin:0 0 20px 0
    }
    /* MODAL ENDS */

    .modalContent tr th{
      text-align:right;
    }

    .modalContent tr .middleDivider{
      width: 50px;
      text-align: center;
    }

    .Aligner {
      display: flex;
      align-items: center;
      justify-content: center;
    }
</style>